const config = {
    baseUrl: process.env.VUE_APP_API_HOST_AWS,
    port: ':8443' ,
    context: '/services/company'
};

export default config